import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';
import axios from 'axios';
import vuexStore from './../../../store/index';

const get = async () => {
  return await axiosIns.get(obtenerUrl('unidad-medida'));
};
const store = async (data) => {
  return await axiosIns.post(obtenerUrl('unidad-medida'), data);
};
const update = async (id, data) => {
  return await axiosIns.put(obtenerUrl(`unidad-medida/${id}`), data);
};
const destroy = async (id) => {
  return await axiosIns.delete(obtenerUrl(`unidad-medida/${id}`));
};
const getUnidades = async () => {
  return await axios.get(process.env.VUE_APP_ENDPOINT_UNIDADES_MEDIDA, {
    headers: {
      'Content-Type': 'application/json',
      Apikey: vuexStore.getters.getApiKey,
    },
  });
};

export default {
  get,
  store,
  update,
  destroy,
  getUnidades,
};
